// German Advanced Vocabulary - 50 unique items
// Each item supports 3 question types: target↔english, definition→target (no romanization)

import { VocabularyItem } from '../../../utils/multipleChoiceLogic';

export const germanAdvancedItems: VocabularyItem[] = [
  // Abstract Concepts (1-10)
  {
    id: 'de-adv-001',
    target: 'die Freiheit',
    english: 'freedom',
    definition: 'The state of being free from restrictions',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-002',
    target: 'die Wahrheit',
    english: 'truth',
    definition: 'The quality of being true or factual',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-003',
    target: 'die Gerechtigkeit',
    english: 'justice',
    definition: 'Fair treatment according to the law',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-004',
    target: 'die Verantwortung',
    english: 'responsibility',
    definition: 'The state of being accountable for something',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-005',
    target: 'die Entwicklung',
    english: 'development',
    definition: 'The process of growing or progressing',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-006',
    target: 'die Erfahrung',
    english: 'experience',
    definition: 'Knowledge gained through involvement',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-007',
    target: 'die Beziehung',
    english: 'relationship',
    definition: 'A connection between people or things',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-008',
    target: 'die Gesellschaft',
    english: 'society',
    definition: 'The community of people living together',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-009',
    target: 'die Wissenschaft',
    english: 'science',
    definition: 'Systematic study of the natural world',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-010',
    target: 'die Kultur',
    english: 'culture',
    definition: 'The customs and beliefs of a group',
    partOfSpeech: 'noun'
  },

  // Business & Professional (11-20)
  {
    id: 'de-adv-011',
    target: 'das Unternehmen',
    english: 'company / enterprise',
    definition: 'A business organization',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-012',
    target: 'die Wirtschaft',
    english: 'economy',
    definition: 'The system of production and consumption',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-013',
    target: 'der Vertrag',
    english: 'contract',
    definition: 'A legally binding agreement',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-014',
    target: 'die Besprechung',
    english: 'meeting / discussion',
    definition: 'A gathering to discuss matters',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-015',
    target: 'der Erfolg',
    english: 'success',
    definition: 'The achievement of a goal',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-016',
    target: 'die Lösung',
    english: 'solution',
    definition: 'An answer to a problem',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-017',
    target: 'die Entscheidung',
    english: 'decision',
    definition: 'A choice made after consideration',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-018',
    target: 'der Fortschritt',
    english: 'progress',
    definition: 'Forward movement toward a goal',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-019',
    target: 'die Herausforderung',
    english: 'challenge',
    definition: 'A difficult task that tests abilities',
    partOfSpeech: 'noun'
  },
  {
    id: 'de-adv-020',
    target: 'das Ziel',
    english: 'goal / target',
    definition: 'An aim or desired result',
    partOfSpeech: 'noun'
  },

  // Emotions & States (21-30)
  {
    id: 'de-adv-021',
    target: 'begeistert',
    english: 'enthusiastic',
    definition: 'Feeling intense excitement',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-adv-022',
    target: 'enttäuscht',
    english: 'disappointed',
    definition: 'Feeling let down or dissatisfied',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-adv-023',
    target: 'überzeugt',
    english: 'convinced',
    definition: 'Firmly believing something is true',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-adv-024',
    target: 'zufrieden',
    english: 'satisfied / content',
    definition: 'Feeling pleased with a situation',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-adv-025',
    target: 'besorgt',
    english: 'worried / concerned',
    definition: 'Feeling anxious about something',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-adv-026',
    target: 'überrascht',
    english: 'surprised',
    definition: 'Feeling astonishment at something unexpected',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-adv-027',
    target: 'neugierig',
    english: 'curious',
    definition: 'Eager to learn or know something',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-adv-028',
    target: 'dankbar',
    english: 'grateful',
    definition: 'Feeling thankful for something',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-adv-029',
    target: 'stolz',
    english: 'proud',
    definition: 'Feeling pleased about an achievement',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-adv-030',
    target: 'unsicher',
    english: 'uncertain / insecure',
    definition: 'Lacking confidence or certainty',
    partOfSpeech: 'adjective'
  },

  // Advanced Verbs (31-40)
  {
    id: 'de-adv-031',
    target: 'erreichen',
    english: 'to achieve / to reach',
    definition: 'To successfully accomplish a goal',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-adv-032',
    target: 'entwickeln',
    english: 'to develop',
    definition: 'To grow or cause to grow',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-adv-033',
    target: 'beeinflussen',
    english: 'to influence',
    definition: 'To have an effect on something',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-adv-034',
    target: 'unterstützen',
    english: 'to support',
    definition: 'To give assistance to someone',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-adv-035',
    target: 'verbessern',
    english: 'to improve',
    definition: 'To make something better',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-adv-036',
    target: 'vermeiden',
    english: 'to avoid',
    definition: 'To keep away from something',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-adv-037',
    target: 'berücksichtigen',
    english: 'to consider / to take into account',
    definition: 'To think carefully about something',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-adv-038',
    target: 'vorschlagen',
    english: 'to suggest / to propose',
    definition: 'To put forward an idea for consideration',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-adv-039',
    target: 'überzeugen',
    english: 'to convince',
    definition: 'To cause someone to believe something',
    partOfSpeech: 'verb'
  },
  {
    id: 'de-adv-040',
    target: 'vergleichen',
    english: 'to compare',
    definition: 'To examine similarities and differences',
    partOfSpeech: 'verb'
  },

  // Idiomatic Expressions & Complex Words (41-50)
  {
    id: 'de-adv-041',
    target: 'allerdings',
    english: 'however / though',
    definition: 'Used to introduce a contrasting point',
    partOfSpeech: 'adverb'
  },
  {
    id: 'de-adv-042',
    target: 'selbstverständlich',
    english: 'of course / naturally',
    definition: 'Obviously true or expected',
    partOfSpeech: 'adverb'
  },
  {
    id: 'de-adv-043',
    target: 'wahrscheinlich',
    english: 'probably',
    definition: 'Most likely to happen',
    partOfSpeech: 'adverb'
  },
  {
    id: 'de-adv-044',
    target: 'offensichtlich',
    english: 'obviously',
    definition: 'Easily perceived or understood',
    partOfSpeech: 'adverb'
  },
  {
    id: 'de-adv-045',
    target: 'grundsätzlich',
    english: 'fundamentally / in principle',
    definition: 'Relating to the basic nature of something',
    partOfSpeech: 'adverb'
  },
  {
    id: 'de-adv-046',
    target: 'ausgezeichnet',
    english: 'excellent',
    definition: 'Extremely good or outstanding',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-adv-047',
    target: 'umfangreich',
    english: 'extensive / comprehensive',
    definition: 'Covering a large area or range',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-adv-048',
    target: 'zuverlässig',
    english: 'reliable',
    definition: 'Consistently good in quality or performance',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-adv-049',
    target: 'verantwortlich',
    english: 'responsible',
    definition: 'Having an obligation to do something',
    partOfSpeech: 'adjective'
  },
  {
    id: 'de-adv-050',
    target: 'unbedingt',
    english: 'absolutely / definitely',
    definition: 'Without any doubt or condition',
    partOfSpeech: 'adverb'
  }
];
